import React from 'react';
import PropTypes from 'prop-types';
import css from './SFTab.css';

export default class SFTab extends React.Component {

  constructor() {
    super();
    this.divRef = React.createRef();
  }

  componentDidMount() {
    this.props.renderComponent(this.divRef.current);
  }

  render() {
    return <div className={css['container']} ref={this.divRef} />;
  }
}

SFTab.propTypes = {
  renderComponent: PropTypes.func.isRequired
};
